import { range } from 'ramda';

export const generateArr = (n: number) =>
  Array.from(Array(n), (i, index) => {
    return {
      label: index + 1,
      value: index + 1,
    };
  });

type HourOfDay =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23;

export type TimeOfDay = `${HourOfDay}:00`;
const _times = range(0, 24).map(
  (x) => `${x < 10 ? '0' : ''}${x}:00` as TimeOfDay,
);

export const times = () => _times;

export const sixWeeks = generateArr(6);
export const weeks = generateArr(4);
export const months = generateArr(12);
export const monthDays = generateArr(31);
